function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmoothConnectionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "46.774 84.531 388.534 287.138",
    width: 388.534,
    height: 287.138,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(63, 63, 63)"
    },
    x: 155.314,
    y: 84.531,
    width: 172.785,
    height: 83.544,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(63, 63, 63)"
    },
    x: 287.082,
    y: 300,
    width: 148.226,
    height: 71.669,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(63, 63, 63)"
    },
    x: 46.774,
    y: 300,
    width: 148.226,
    height: 71.669,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "none",
      strokeWidth: 5
    },
    d: "M 241.443 168.354 L 241.443 224.108 L 121.188 224.108 L 121.188 300"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "none",
      strokeWidth: 5
    },
    d: "M 361.444 300 L 361.444 244.246 L 241.189 244.246 L 241.189 168.354",
    transform: "matrix(-1, 0, 0, -1, 602.632996, 468.354004)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothConnectionLight);
export default __webpack_public_path__ + "static/media/smoothConnectionLight.e7c3df897341bc201a68416d41316a65.svg";
export { ForwardRef as ReactComponent };